import { apiGet } from '../../api'

export const get_stoplight = () => {
  return apiGet({
    endpoint: 'stoplight/get_stoplight'
  })
}
